const Constants = {
  /***
   * Initialized as false but it will get set to the value of the environment variable in apps/applicant-portal/constants.ts.
   * The environment variable is set to match the backend in the different environments in argo-cd-apps.
   * It was added to prevent a call to the one-id-options endpoint which seems to be slow even on production where demo responses are disabled
   */
  enableDemoResponses: false,
};

export default Constants;
